import { render } from "./viewlesaviezvous.vue?vue&type=template&id=08379f94"
import script from "./viewlesaviezvous.vue?vue&type=script&lang=js"
export * from "./viewlesaviezvous.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__